import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared';
import { useTranslation } from 'react-i18next';

interface TextareaFormFieldProps extends UpdateTermineFormProps {
  name: 'beschreibung' | 'specials';
}

export function TextAreaFormField({ name, form }: TextareaFormFieldProps) {
  const { t } = useTranslation();

  return (
    <form.AppField name={name}>
      {(field) => (
        <field.TextArea
          label={
            name === 'beschreibung'
              ? t('domain.termine.description')
              : t('domain.termine.additionalInformation')
          }
        />
      )}
    </form.AppField>
  );
}
